export const handleImmixServerInput = (
  camerasObject: any,
  setCamerasObject: any,
  inputString: string
) => {
  // Update localStorage first so AutoAddTable doesn't overwrite our changes
  const immixAlertPostObject = JSON.parse(
    localStorage.immixAlertPostObject || "{}"
  );
  immixAlertPostObject.immix_server = inputString;
  localStorage.setItem(
    "immixAlertPostObject",
    JSON.stringify(immixAlertPostObject)
  );

  // Create a deep copy of the camerasObject to ensure React detects the change
  const newCamerasObject = { ...camerasObject };

  for (const key in camerasObject) {
    newCamerasObject[key] = {
      ...camerasObject[key],
      immix: {
        ...camerasObject[key].immix,
      },
    };
    newCamerasObject[key].immix.immix_server = inputString;
  }

  setCamerasObject(newCamerasObject);
};
